module.exports = __webpack_public_path__ + "img/apple-music.63b7d932.png";